<template>
    <v-container fluid grid-list-lg>
        <v-progress-linear indeterminate v-if="loading"/>
        <div v-else>
            <v-layout>
                <v-flex md3>
                    <div class="headline pb-2">Administrasjonskostnader</div>
                    <v-card class="pa-3">
                        <v-list-item v-for="year in years" :key="year">
                            <v-list-item-avatar>{{ year }}</v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <v-text-field filled label="Administrasjonskostnader" type="number"
                                                  step="0.1" hide-details suffix="%" :value="yearCosts[year]"
                                                  @input="syncYear(year, $event)"></v-text-field>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout class="pt-3 px-2">
                <v-btn :loading="saving" color="green" dark @click="save">Lagre administrasjonskostnader</v-btn>
            </v-layout>
        </div>
    </v-container>
</template>

<script>


import * as dayjs from "dayjs";

export default {
    data() {
        return {
            loading: false,
            saving: false,
            yearCosts: {}
        }
    },

    created() {
        this.loadData();
    },

    methods: {
        loadData() {
            this.loading = true;
            this.$http.get(`admin-costs/`).then(response => {
                this.yearCosts = response.data;
            }).finally(() => {
                this.loading = false;
            });
        },
        syncYear(year, value) {
            this.yearCosts[year] = value;
        },
        save() {
            this.saving = true;
            this.$http.post(`admin-costs/`, this.yearCosts).then(response => {
                this.$root.addMessage('Adm.kost. lagret.', 'green');
                this.yearCosts = response.data;
            }).catch(() => {
                this.$root.addMessage('Adm.kost. ikke lagret.', 'red');
            }).finally(() => {
                this.saving = false;
            })
        }
    },

    computed: {
        years() {
            let nextYear = dayjs().year() + 1;
            let years = [];
            for (let i = nextYear; i >= 2009; i--) {
                years.push(i);
            }

            return years;
        }
    }
}
</script>